<template>
    <div class="fromToBox">
        <md-field>
            <label>{{$t('common.placeholder.range.start', { name: labelText })}}</label>
            <MoneyAmountInput v-model="fromValue" :decimals="decimals"></MoneyAmountInput>
        </md-field>
        <md-field>
            <label>{{$t('common.placeholder.range.end', { name: labelText })}}</label>
            <MoneyAmountInput v-model="toValue" :decimals="decimals"></MoneyAmountInput>
        </md-field>
    </div>
</template>

<script>
import MoneyAmountInput from "@/components/templates/common/MoneyAmountInput";

export default {
    components: { MoneyAmountInput },
    props: {
        fieldType: { type: String, default: "C" },
        labelText: { type: String },
        columnName: { type: String },
        initialFromValue: { type: Number | null, default: null },
        initialToValue: { type: Number | null, default: null }
    },
    data() {
        return {
            fromValue: this.initialFromValue,
            toValue: this.initialToValue,
            decimals: this.fieldType === "I" || this.fieldType === "L" ? 0 : 2,
        };
    },
    methods: {
        clearFilter() {
            this.fromValue = null;
            this.toValue = null;
        },
        getFilter() {
            let filters = [];

            if (this.fromValue !== null) {
                filters.push(                {
                    columnName: this.columnName,
                    fieldType: this.fieldType,
                    matchType: "GE",
                    value: this.fromValue
                });
            }

            if (this.toValue !== null) {
                filters.push(                {
                    columnName: this.columnName,
                    fieldType: this.fieldType,
                    matchType: "LE",
                    value: this.toValue
                });
            }

            return filters.length > 0 ? filters : null;
        },
        setFilter(filter) {
            if (filter.matchType === "GE") {
                this.fromValue = filter.value;
            } else if (filter.matchType === "LE") {
                this.toValue = filter.value;
            }
        }
    },
};
</script>


<style lang="scss" scoped>
.fromToBox {
    display: flex;
    justify-content: space-between;
}

.fromToBox input {
    width: 120px;
}
</style>